/* eslint-disable react/prop-types */
import _ from 'underscore';
import classnames from 'classnames';
import React, { useMemo } from 'react';

import { getAdPlacementComponent } from './get-ad-placement-component';
import { withUAPLThemedStyles } from '../with-themed-styles';
import { getAdPreviewGridLayoutStyles } from '../styles';
import { pickSingleImageFromImageList } from '../ad-preview-model/use-ad-preview-model';

// import {
//   UAPVMSingleImagePlacement as TSingleImageViewModel,
//   UAPVMPlacement as TMultiImageViewModel,
// } from '../@types';

// interface GridLayoutProps {
//   placementList: Array<TSingleImageViewModel | TMultiImageViewModel> | undefined | null;
//   onRenderPlacement: Function;
//   onRenderEmptyView?: Function | undefined | null;
//   gridLayoutContainerClassName?: String | undefined | null;
//   classes: {
//     adPreviewGridLayoutContainer: string;
//   };
// }

const GridLayout /* : React.FC<GridLayoutProps> */ = ({
  placementList,
  onRenderPlacement,
  onRenderEmptyView,
  gridLayoutContainerClassName,
  classes,
}) => {
  const emptyView = useMemo(() => {
    if (onRenderEmptyView) {
      return onRenderEmptyView(placementList);
    }
    return null;
  }, [onRenderEmptyView, placementList]);

  const placementComponentList = useMemo(() => {
    const ret = _.map(placementList, (placement, index) => {
      const { placementMeta, images, ...rest } = placement || {};
      const { placementType, hasMultiImages } = placementMeta || {};
      const AdPlacementComponent = getAdPlacementComponent(placementType);
      if (AdPlacementComponent) {
        // convert multi-image model to single-image model if needed
        let newPlacement = placement;
        if (!hasMultiImages && !_.isEmpty(images)) {
          const selectedImage = pickSingleImageFromImageList(images) || {};
          newPlacement = { placementMeta, ...selectedImage, ...rest };
        }
        return onRenderPlacement(newPlacement, AdPlacementComponent, index);
      }
      return null;
    });
    return ret;
  }, [onRenderPlacement, placementList]);

  return !_.isEmpty(placementComponentList) ? (
    <div className={classnames(classes.adPreviewGridLayoutContainer, gridLayoutContainerClassName)} >
      {placementComponentList}
    </div>
  ) : emptyView;
};

export const AdPreviewGridLayout = withUAPLThemedStyles(
  GridLayout,
  getAdPreviewGridLayoutStyles,
  { componentName: 'AdPreviewGridLayout' }
);
